import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";
import { runSafelyWithServerClient } from "../api/server.api";
import { cardTitleStyle, overviewCardStyle } from "./backofficeTheme";

export function ResetPasswordSection(props: { name: string; email?: string; noEmailErrorMessage: string }) {
  const { name, email, noEmailErrorMessage } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleCancel() {
    setDialogOpen(false);
  }

  async function handleConfirm() {
    setLoading(true);
    try {
      const trimmedEmail = email?.trim();
      if (!trimmedEmail) {
        showErrorToast(noEmailErrorMessage);
        setLoading(false);
        return;
      }
      await runSafelyWithServerClient((serverClient) => serverClient.sendPasswordResetEmail({ email: trimmedEmail }), {
        successMessage:
          "Wir haben der Person eine E-Mail mit weiteren Anweisungen geschickt. Bitte prüfe das E-Mail-Postfach.",
        errorMessage: "Fehler beim Versenden der E-Mail zum Zurücksetzen des Passworts.",
        onSuccess: handleCancel,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box sx={overviewCardStyle}>
      <Typography sx={cardTitleStyle}>Passwort zurücksetzen</Typography>
      <Button variant="outlined" onClick={() => setDialogOpen(true)}>
        Passwort zurücksetzen
      </Button>
      <Dialog open={dialogOpen} onClose={handleCancel}>
        <DialogTitle>Passwort zurücksetzen</DialogTitle>
        <DialogContent sx={{ pt: 2, minWidth: 400 }}>
          <Typography>
            Wenn du das Passwort von <strong>{name}</strong> zurücksetzt, wird eine E-Mail mit weiteren Anweisungen an
            die hinterlegte Adresse gesendet.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <LoadingButton onClick={handleCancel} variant="outlined">
            Abbrechen
          </LoadingButton>
          <LoadingButton onClick={handleConfirm} variant="contained" loading={loading}>
            Passwort zurücksetzen
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
